import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthenticationService } from './authentication.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { UsersService } from './users.service';

@Injectable()
export class RoleGuard implements CanActivate, CanActivateChild, CanLoad {

  constructor(
    private authenticationService: AuthenticationService,
    private usersService: UsersService,
    private router: Router) { }

  canLoad(route: Route): Observable<boolean> | boolean {
    return this.usersService.currentUser.map(user => {
      let canAccess = false;

      if (user) {
        const routeRoles = route.data['roles'] as Array<string>;
        canAccess = user.roles.filter(r => routeRoles.indexOf(r.name) !== -1).length > 0;
      }

      if (!canAccess) {
        this.router.navigate([]);
      }

      return canAccess;
    });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.usersService.currentUser.map(user => {
      let canAccess = false;

      if (user) {
        const routeRoles = route.data['roles'] as Array<string>;
        canAccess = user.roles.filter(r => routeRoles.indexOf(r.name) !== -1).length > 0;
      }

      if (!canAccess) {
        this.router.navigate([]);
      }

      return canAccess;
    });

  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(route, state);
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/services/role-guard.service.ts